import _filter from 'lodash.filter'
import PaymentGateways from '../strategy/payment/constants'
class StoreUtils {
  getPaymentGateways(store) {
    const paymentGateways = _filter(store.paymentGateways, { isDefault: true })
    return paymentGateways
  }
  getFormatPaypalLanguage(lang, countryCode) {
    const currentCountryCode = countryCode || 'AR'
    const language = lang || 'es'
    return `${language.toLowerCase()}_${currentCountryCode.toUpperCase()}`
  }

  getIsLightIntegration(paymentGateways) {
    const { type: paymentType } = paymentGateways.find(
      (paymentGatewayItem) => paymentGatewayItem.isDefault === true,
    )
    return paymentType === PaymentGateways.LIGHT
  }

  getBackgroundImage({ isMobile, backgroundUrlMobile = null, backgroundUrl }) {
    return isMobile && backgroundUrlMobile ? backgroundUrlMobile : backgroundUrl
  }

  reloadWindow() {
    window.location.reload(true)
  }
}

const instance = new StoreUtils()
Object.freeze(instance)

export default instance
